import { BrandCategory } from '@/interfaces/Menu';
import styles from './MenuCategory.module.scss';

interface MenuCategoryProps {
  category: BrandCategory;
  isActive?: boolean;
  onClick?: () => void;
  'data-category-id'?: string;
}

const MenuCategory = ({
  category,
  isActive = false,
  onClick,
  'data-category-id': dataCategoryId,
}: MenuCategoryProps) => {
  return (
    <button
      className={`${styles.category} ${isActive ? styles.active : ''}`}
      onClick={onClick}
      data-category-id={dataCategoryId}
      data-testid={`menu-category-${category.id}`}
    >
      {category.name}
    </button>
  );
};

export default MenuCategory;
